import logo from './img/logo.png';


function Homepage() {
  return (
    <header className="App-header">
      <img src={logo} className="App-logo" alt="NAOI 2025" />
      <p>
        The 1<sup>st</sup> North African Olympiad in Informatics
      </p>
      <p>
        April 19th, 2025
      </p>
    </header>
  );
}

export default Homepage;
